const firebaseConfig = {
    apiKey: "AIzaSyBa91FjYpodS9p2celv32Vai8P0WerUd3s",
    authDomain: "journey-riders.firebaseapp.com",
    projectId: "journey-riders",
    storageBucket: "journey-riders.appspot.com",
    messagingSenderId: "705830184135",
    appId: "1:705830184135:web:9641a0451b02b236584ae2"
  };
  export default firebaseConfig